import type { HubspotFormConfiguration } from '@mnd-apps/public/lib/getHubspotForm';
import type { PageFragment } from '../../../wp-generated/types';
import Hero from './2025design/Hero';
import HeroForm from './2025design/HeroForm';
import HeroFormTrial from './2025design/HeroFormTrial';
import HeroOld from './Hero';
import HeroAi from './HeroAi';
import HeroBg from './HeroBg';
import HeroCenter from './HeroCenter';
import HeroFormOld from './HeroForm';
import HeroTrialOld from './HeroTrial';

const HeroSelector = ({
  hero,
  pageName,
  noticeIsOpen,
  hubspotFormConfig,
}: {
  hero: PageFragment['hero'];
  pageName: string;
  noticeIsOpen?: boolean;
  hubspotFormConfig: HubspotFormConfiguration | undefined;
}) => {
  if (hero && hero.heroTemplate) {
    for (const template of hero.heroTemplate) {
      switch (template) {
        case 'hero':
          return hero.hero?.use2025Design ? (
            <Hero data={hero.hero} noticeIsOpen={noticeIsOpen} />
          ) : (
            <HeroOld data={hero.hero} />
          );
        case 'hero-center':
          return hero.heroCenter?.use2025Design ? (
            <div>new design placeholder (HeroCenter)</div>
          ) : (
            <HeroCenter data={hero.heroCenter} />
          );
        case 'hero-form':
          return hero.heroForm?.use2025Design ? (
            <HeroForm
              data={hero.heroForm}
              hubspotFormConfig={hubspotFormConfig!}
              formTrackingName={pageName}
            />
          ) : (
            <HeroFormOld data={hero.heroForm} formTrackingName={pageName} />
          );
        case 'hero-trial':
          return hero.heroTrial?.use2025Design ? (
            <HeroFormTrial data={hero.heroTrial} />
          ) : (
            <HeroTrialOld data={hero.heroTrial} />
          );
        case 'hero-ai':
          return hero.heroAi?.use2025Design ? (
            <div>new design placeholder (HeroAi)</div>
          ) : (
            <HeroAi data={hero.heroAi} />
          );
        case 'hero-bg':
          return hero.heroBg?.use2025Design ? (
            <div>new design placeholder (HeroBg)</div>
          ) : (
            <HeroBg data={hero.heroBg} />
          );
        default:
          continue;
      }
    }
  }
  return null;
};

export default HeroSelector;
